import { emitLog } from './emit.util';

export type LogMeta = Record<string, unknown>;

export interface Logger {
  lifecycle: (message: string, meta?: unknown, ...extraArgs: unknown[]) => void;
  debug: (message: string, meta?: unknown, ...extraArgs: unknown[]) => void;
  warn: (message: string, meta?: unknown, ...extraArgs: unknown[]) => void;
  error: (message: string, meta?: unknown, ...extraArgs: unknown[]) => void;
}

export const logger: Logger = {
  lifecycle: (message: string, meta?: unknown, ...extraArgs: unknown[]): void => {
    emitLog('lifecycle', message, meta === undefined ? extraArgs : [meta, ...extraArgs]);
  },
  debug: (message: string, meta?: unknown, ...extraArgs: unknown[]): void => {
    emitLog('debug', message, meta === undefined ? extraArgs : [meta, ...extraArgs]);
  },
  warn: (message: string, meta?: unknown, ...extraArgs: unknown[]): void => {
    emitLog('warn', message, meta === undefined ? extraArgs : [meta, ...extraArgs]);
  },
  error: (message: string, meta?: unknown, ...extraArgs: unknown[]): void => {
    emitLog('error', message, meta === undefined ? extraArgs : [meta, ...extraArgs]);
  },
};

export default logger;
